import { render, staticRenderFns } from "./TruckTractor.vue?vue&type=template&id=42f928a1&scoped=true&"
import script from "./TruckTractor.vue?vue&type=script&lang=js&"
export * from "./TruckTractor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f928a1",
  null
  
)

export default component.exports